<template>
  <svg viewBox="0 0 512.061 512.061" :height="`${height}px` || '24px'" :width="`${width}px` || '24px'" :class="`fill-current  text-${color}`">
    <g>
      <g>
        <path
          d="m110.034 265.573-77.784-77.784c-20.777-20.777-32.22-48.401-32.22-77.785 0-60.656 49.348-110.004 110.004-110.004 60.657 0 110.004 49.348 110.004 110.004 0 29.384-11.442 57.008-32.22 77.785zm0-235.573c-44.114 0-80.004 35.89-80.004 80.004 0 21.37 8.322 41.461 23.433 56.572l56.571 56.571 56.572-56.571c15.111-15.111 23.433-35.202 23.433-56.572 0-44.114-35.89-80.004-80.005-80.004z"
        />
      </g>
      <g>
        <path
          d="m110.034 160.008c-27.571 0-50.002-22.431-50.002-50.002s22.431-50.002 50.002-50.002 50.002 22.431 50.002 50.002-22.431 50.002-50.002 50.002zm0-70.004c-11.029 0-20.002 8.973-20.002 20.002s8.973 20.002 20.002 20.002 20.002-8.973 20.002-20.002-8.973-20.002-20.002-20.002z"
        />
      </g>
      <g>
        <path
          d="m432.026 512.061-56.573-56.571c-15.109-15.111-23.431-35.202-23.431-56.572 0-44.114 35.89-80.004 80.004-80.004s80.004 35.89 80.004 80.004c0 21.369-8.321 41.46-23.432 56.572zm-35.359-77.785 35.359 35.358 35.358-35.358c9.444-9.445 14.646-22.003 14.646-35.359 0-27.572-22.432-50.004-50.004-50.004s-50.004 22.432-50.004 50.004c0 13.357 5.202 25.915 14.645 35.359z"
        />
      </g>
      <g>
        <path
          d="m359.031 512h-167.453c-53.234 0-96.543-43.309-96.543-96.543s43.309-96.544 96.543-96.544h55.664c16.419 0 29.776-13.357 29.776-29.776s-13.357-29.776-29.776-29.776h-58.202v-30h58.202c32.961 0 59.776 26.815 59.776 59.776s-26.815 59.776-59.776 59.776h-55.664c-36.692 0-66.543 29.851-66.543 66.543s29.85 66.544 66.543 66.544h167.454v30z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#333'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
